{
  "sign_in": "Sign in",
  "sign_up": "Sign up",
  "no_account_question": "Don't have an account?",
  "register_here": "Register here",
  "have_account_question": "Already have an account?",
  "sign_in_here": "Sign in here",
  "or_divider": "OR",
  "login_with_ebirdie": "Sign in with eBirdie",
  "login_with_google": "Sign in with Google",
  "login_with_apple": "Sign in with Apple",
  "forgot_password_question": "Forgot your password?",
  "reset_password_action": "Reset password",
  "signing_in": "Signing in...",
  "signing_up": "Signing up...",
  "minimum_8_characters": "Minimum 8 characters",
  "forgot_password": "Forgot password?",
  "continue_with": "or continue with",
  "continue_with_google": "Google",
  "already_have_account": "Already have an account?",
  "dont_have_account": "Don't have an account?",
  "completing_login": "Completing login...",
  "oauth_login_failed": "Login failed",
  "missing_auth_tokens": "Missing authentication tokens",
  "auth_successful_but_failed_load": "Authentication successful but failed to load user data",
  "authentication_failed": "Authentication failed",
  "enter_email_for_reset": "Enter your email address and we'll send you a link to reset your password.",
  "send_reset_email": "Send reset email",
  "sending_reset_email": "Sending reset email...",
  "password_reset_sent": "Password reset email sent successfully",
  "check_your_email": "Check your email",
  "password_reset_instructions": "We've sent a password reset link to your email address. Please check your inbox and click the link to reset your password.",
  "back_to_login": "Back to login",
  "reset_password": "Reset password",
  "enter_new_password": "Enter your new password below.",
  "new_password": "New password",
  "confirm_new_password": "Confirm new password",
  "confirm_password": "Confirm password",
  "resetting_password": "Resetting password...",
  "password_reset_success": "Password reset successfully",
  "invalid_or_expired_token": "Invalid or expired reset token",
  "invalid_reset_link": "Invalid reset link",
  "validating_reset_link": "Validating reset link...",
  "reset_link_expired_or_invalid": "This password reset link has expired or is invalid.",
  "request_new_reset_link": "Request a new reset link",
  "password_reset_complete": "Password reset complete",
  "password_reset_complete_message": "Your password has been successfully reset. You can now sign in with your new password.",
  "continue_to_login": "Continue to login",
  "complete_profile_title": "Complete Your Profile",
  "username": "Username",
  "username_required": "Username is required",
  "username_length": "Username must be between 3 and 50 characters",
  "username_invalid": "Username can only contain letters, numbers, and underscores",
  "username_taken": "This username is already taken",
  "checking_availability": "Checking availability...",
  "first_name": "First Name",
  "last_name": "Last Name",
  "handicap": "Handicap",
  "handicap_invalid": "Handicap must be between -10 and 54",
  "gender": "Gender",
  "gender_not_specified": "Not Specified",
  "gender_male": "Male",
  "gender_female": "Female",
  "gender_other": "Other",
  "complete_profile_button": "Complete Profile",
  "completing_profile": "Completing Profile...",
  "profile_completed": "Profile completed successfully!",
  "profile_completion_error": "Failed to complete profile. Please try again.",
  "registration_successful": "Registration successful!",
  "account_deleted_successfully": "Account deleted successfully",
  "account_deletion_failed": "Failed to delete account",
  "verifying_email": "Verifying your email...",
  "please_wait": "Please wait while we verify your email address.",
  "verification_success": "Email Verified!",
  "verification_failed_title": "Verification Failed",
  "redirecting": "Redirecting you in a moment...",
  "verify_email_title": "Check Your Email",
  "verify_email_message": "We sent a verification link to",
  "verification_link_expires": "The verification link will expire in 24 hours. If you don't see the email, please check your spam folder.",
  "go_to_login": "Go to Login",
  "login_failed": "Login failed",
  "too_many_attempts": "Too many login attempts. Please try again later.",
  "ebirdie_username": "Finnish Golf ID",
  "ebirdie_username_placeholder": "Finnish Golf ID or email",
  "ebirdie_invalid_credentials": "Invalid Golf ID credentials",
  "ebirdie_service_unavailable": "Golf ID service is unavailable. Please try again later.",
  "ebirdie_login_failed": "Golf ID login failed",
  "ebirdie_fetch_title": "Fetching Data from eBirdie",
  "ebirdie_fetch_description": "When you register, your information (name, age, club, membership number and handicap) will be automatically fetched from the Finnish Golf Union's eBirdie system.",
  "ebirdie_accept_terms": "I accept the terms",
  "first_name_required": "First name is required",
  "last_name_required": "Last name is required",
  "email_change": {
    "confirming": "Confirming email address change...",
    "success_title": "Email address changed",
    "failed_title": "Confirmation failed",
    "go_to_app": "Go to app"
  }
}
